import { Country } from "asosteam";
import { createContext, useContext, ReactNode } from "react";

type StoreContextType = {
  countryData: Country;
  keyStoreDataversion: string;
  shop: string;
  versionManifest: VersionManifest;
};

// This should never be undefined as it is server-side rendered.
// As such this should never be used outside of the Store.Provider
const defaultContext: StoreContextType = {} as StoreContextType;
const StoreContext = createContext<StoreContextType>(defaultContext);

export type StoreProviderProps = {
  children: ReactNode;
  countryData: Country;
  keyStoreDataversion: string;
  shop: string;
  versionManifest: VersionManifest;
};

export const Provider = ({
  children,
  countryData,
  keyStoreDataversion,
  shop,
  versionManifest,
}: StoreProviderProps) => {
  return (
    <StoreContext.Provider
      value={{
        countryData,
        keyStoreDataversion,
        shop,
        versionManifest,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (context === defaultContext) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};
